module.exports = "/static/assets/09469790f10bcd5ed51fe8f85f8bdc1e.svg";